window.Stancer = {

    loadPrefs: function ()
    {
        window.sellsyapp.config.globalProperties.$store.dispatch('popupPanel/open', {
            key: 'stancerModal',
            props: {},
        });
    },

};
